import skirmifyRulesText from "./skirmificationHelper";

const ruleTransforms = [
  {
    regex: /that already finished an activation this round/gim,
    replace: `for the first time each round`
  },
  {
    regex: /instead of only when attacking units that already finished an activation/gim,
    replace: `instead of only when attacking for the first time each round`
  },
  {
    regex: /as long as they haven't started an activation yet this round/gim,
    replace: `the first time they are attacked each round`
  },
  {
    regex: /instead of only as long as they haven't started an activation yet/gim,
    replace: `instead of only the first time they are attacked each round`
  }
];

export function questifyRuleText(text: string, ai: boolean, calcSettings: any): string {
  let questRule = skirmifyRulesText(text, calcSettings);

  for (const ruleTransform of ruleTransforms) {
    if (ruleTransform.regex.test(text)) {
      const replace = ruleTransform.replace; // || ruleTransform.getReplacer(calcSettings);
      questRule = text.replace(ruleTransform.regex, replace as any); // + (ruleTransform.append ?? "");
    }
  }

  if (ai) {
    questRule = questRule.replace(/(\d+) friendly unit/, `$1 nearest friendly unit`);
  } else {
    if (
      /(friendly|enemy) units? within \d/.test(questRule) ||
      questRule.endsWith("until the end of the round.")
    ) {
      questRule = "Only one use per game. " + questRule;
    }
    if (/This model and up to \d+ friendly units picked before the start of the game/gi.test(questRule)) {
      questRule += " This effect lasts until the first wave of reinforcements is deployed.";
    }
  }

  return questRule;
}
